import Configuration from '../configuration';
import { $httpProvider } from '../providers';

function getAntennisteList(numeroAnfr, rayonMax) {
  return $httpProvider()({
    method: 'GET',
    url: Configuration.getAntennisteList,
    urlConfig: {
      pathParams: {
        numeroanfr: numeroAnfr,
        rayon: rayonMax
      }
    }
  }).then(r => r.data);
}

export default {
  getAntennisteList
};



// WEBPACK FOOTER //
// ./src/repositories/liste-antenniste.repository.js